import { Column, Entity, Index, JoinColumn, ManyToOne, Unique } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';
import { ConversationToolEntity } from './conversation-tool.entity';

@Entity('_conversation_agent_tool')
@Unique('uk_agent_tool', ['agentId', 'toolId', 'deletedDate'])
export class ConversationAgentToolEntity extends BaseEntity {
	@Column({
		name: 'fk_conversation_agent__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	@Index('idx_agent_tool_agent')
	public agentId!: number;

	@Column({
		name: 'fk_conversation_tool__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	@Index('idx_agent_tool_tool')
	public toolId!: number;

	@Column({ name: 'metadata', type: 'json', nullable: true })
	public metadata?: any;

	// Relationships
	@ManyToOne(() => ConversationAgentEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk_conversation_agent__id' })
	public agent!: ConversationAgentEntity;

	@ManyToOne(() => ConversationToolEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk_conversation_tool__id' })
	public tool!: ConversationToolEntity;

	// Indexes
	@Index('idx_agent_tool_owner')
	public static ownerIndex: string = '_owner_userId';
}
